<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>Operator</mat-label>
    <textarea matInput formControlName="raw"></textarea>
  </mat-form-field>
</ng-container>
<div *ngIf="getFormControl('raw').errors?.invalidJson" i18n>
  Invalid JSON.
</div>
